import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/category/duanshipin?q=${encodeURIComponent(searchText.trim())}`);
      setSearchText("");
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="font-heading text-2xl text-primary-500">久久视频</span>
          </Link>

          <div className="hidden lg:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/"
                  ? "text-primary-500 font-medium"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-500 font-medium"
                    : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/about"
                  ? "text-primary-500 font-medium"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="搜索视频..."
                className="w-48 px-4 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 cursor-pointer transition-colors"
              >
                <i className="ri-search-line"></i>
              </button>
            </form>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="block px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            >
              关于我们
            </Link>
            <form onSubmit={handleSearch} className="px-4 pt-3 pb-2">
              <div className="relative">
                <input
                  type="text"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="搜索视频..."
                  className="w-full px-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
                />
                <button
                  type="submit"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 cursor-pointer transition-colors"
                >
                  <i className="ri-search-line"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </nav>
  );
}